import {Reducer} from "redux";
import {
    ADD_SOURCE,
    ADD_SOURCES, DELETE_SOURCES,
    DESELECT_ALL,
    RESET,
    SELECT_ALL,
    SET_CONTRIBUTION,
    SHORTLIST_ADD,
    SHORTLIST_REMOVE,
    TOGGLE_SELECT,
    UPDATE_ID,
    UPDATE_SOURCE
} from "../action_types/literatureWizardActionTypes";

import IShortlistElement from "../interfaces/IShortlistElement";
import ISource from "../interfaces/ISource";

/**
 * Reducer state
 */
interface ILiteratureWizardReducerState {
    readonly instanceID: string,
    readonly password: string,
    readonly selected: string[],
    readonly shortlist: IShortlistElement[],
    readonly sources: ISource[],
}

/**
 * Initial reducer state
 * @type {{sources: ISource[]}}
 */
const initialState: ILiteratureWizardReducerState = {
    instanceID: '',
    password: '',
    selected: [],
    shortlist: [],
    sources: [],
};

/**
 * Literature wizard action reducers
 * @param {ILiteratureWizardReducerState} state
 * @param action
 * @returns {ILiteratureWizardReducerState}
 * @constructor
 */
const LiteratureWizardReducer: Reducer = (state = initialState, action: any) => {
    switch (action.type) {
        case ADD_SOURCE: {
            return {
                ...state,
                sources: [...state.sources, action.source]
            };
        }

        case ADD_SOURCES: {
            return {
                ...state,
                shortlist: action.instance.shortlist,
                sources: action.instance.sources,
            };
        }

        case UPDATE_SOURCE: {
            const index = state.sources.map((source: ISource) => source._id).indexOf(action.source._id);
            return {
                ...state,
                sources: [...state.sources.slice(0, index), action.source, ...state.sources.slice(index + 1)]
            };
        }

        case SET_CONTRIBUTION: {
            const index = state.sources.map((source: ISource) => source._id).indexOf(action.id);
            const newSource: ISource = {
                ...state.sources[index],
                usability: action.usability
            };
            return {
                ...state,
                sources: [...state.sources.slice(0, index), newSource, ...state.sources.slice(index + 1)]
            };
        }

        case UPDATE_ID: {
            const index = state.sources.map((source: ISource) => source._id).indexOf(action.source.old_id);
            const newSource: ISource = {
                ...state.sources[index],
                _id: action.source._id
            };
            return {
                ...state,
                sources: [...state.sources.slice(0, index), newSource, ...state.sources.slice(index + 1)]
            };
        }

        case SHORTLIST_ADD: {
            const newElement: IShortlistElement = {
                type: action.elementType,
                value: action.value
            };
            return {
                ...state,
                shortlist: [...state.shortlist, newElement]
            };
        }

        case SHORTLIST_REMOVE: {
            let index;

            for (let i = 0; i < state.shortlist.length; ++i) {
                const element = state.shortlist[i];

                if (element.type === action.elementType && element.value === action.value) {
                    index = i;
                }
            }

            if (index === undefined) {
                return state;
            }

            return {
                ...state,
                shortlist: [...state.shortlist.slice(0, index), ...state.shortlist.slice(index + 1)]
            };
        }

        case RESET: {
            return initialState;
        }

        case TOGGLE_SELECT: {
            const index = state.selected.indexOf(action.id);

            if (index !== -1) {
                return {
                    ...state,
                    selected: [...state.selected.slice(0, index), ...state.selected.slice(index + 1)],
                };
            } else {
                return {
                    ...state,
                    selected: [...state.selected, action.id],
                };
            }
        }

        case SELECT_ALL: {
            return {
                ...state,
                selected: state.sources
                    .map((source: ISource) => source._id)
                    .filter((id: string) => id !== undefined)
                    .filter((id: string) => action.ids.indexOf(id) !== -1),
            };
        }

        case DESELECT_ALL: {
            return {
                ...state,
                selected: state.selected
                    .filter((id: string) => action.ids.indexOf(id) === -1),
            };
        }

        case DELETE_SOURCES: {
            const newSources: ISource[] = [];

            for (const source of state.sources) {
                if (action.ids.indexOf(source._id) === -1) {
                    newSources.push(source);
                }
            }

            return {
                ...state,
                sources: newSources,
            };
        }

        /**
         * Default reducer
         */
        default:
            return state;
    }
};

export default LiteratureWizardReducer;


// WEBPACK FOOTER //
// ./src/reducers/literatureWizardReducer.ts